import React from 'react';

export default class Answer extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="answer">
				<div className="answer-content">
					 <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Labore deserunt repellat quam modi incidunt a quod sequi unde nemo mollitia nostrum laboriosam optio vitae, culpa reprehenderit, earum fugiat animi quia.</p>
				</div>
			</div>
		)
	}

}


/** WEBPACK FOOTER **
 ** ./src/components/content/answer.js
 **/